import { useState } from 'react';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import { GiRose } from "react-icons/gi";
import "react-jinke-music-player/assets/index.css";
import ReactPlayer from 'react-player';
import {
    VerticalTimeline,
    VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import useCubit from "../../blocs/hooks";
import { kNavBarHeight } from "../../core/utils/constants";
import { DataTableBloc, IDataTableBloc } from "../core/DataTable/DataTableBloc";
import { DataTableState } from "../core/DataTable/DataTableState";
import Footer from "./Footer";
import Header from "./Header";

function Zahra() {
    const memoriesCubit = new DataTableBloc('memories', [
        {
            name: "ID",
            field: "id",
            type: "text",
            edit: false,
        },
        {
            name: "Title",
            field: "title",
            type: "text"
        },
        {
            name: "Description",
            field: "description",
            type: "text",
        },
        {
            name: "Image",
            field: "image",
            type: "image",
        },
        {
            name: "Video",
            field: "video",
            type: "file",
            show: false,
            edit: true,
        },
        {
            name: "Date",
            field: "date",
            type: "date",
        }
    ])
    const musicsCubit = new DataTableBloc('songs', [
        {
            name: "ID",
            field: "id",
            type: "text",
            edit: false,
        },
        {
            name: "Title",
            field: "title",
            type: "text"
        },
        {
            name: "Cover",
            field: "cover",
            type: "image",
        },
        {
            name: "Audio",
            field: "audio",
            type: "file",
            show: false
        },
    ])
    const headersCubit = new DataTableBloc('headers', [
        {
            name: "ID",
            field: "id",
            type: "text",
            edit: false,
        },
        {
            name: "Title",
            field: "title",
            type: "text"
        },
        {
            name: "Description",
            field: "description",
            type: "text"
        },
        {
            name: "Cover",
            field: "cover",
            type: "image",
        },
    ])
    const footersCubit = new DataTableBloc('footers', [
        {
            name: "ID",
            field: "id",
            type: "text",
            edit: false,
        },
        {
            name: "Title",
            field: "title",
            type: "text"
        },
        {
            name: "Description",
            field: "description",
            type: "text"
        },
    ])

    return <div style={{ paddingTop: kNavBarHeight }}>
        <ZahraBody
            memoriesCubit={memoriesCubit}
            musicsCubit={musicsCubit}
            footersCubit={footersCubit}
            headersCubit={headersCubit}
        />
    </div>
}



interface ZahraBodyProps {
    memoriesCubit: IDataTableBloc;
    musicsCubit: IDataTableBloc;
    headersCubit: IDataTableBloc;
    footersCubit: IDataTableBloc;
}

function ZahraBody(props: ZahraBodyProps) {
    const memoriesState = useCubit<DataTableState>(props.memoriesCubit)
    const musicsState = useCubit<DataTableState>(props.musicsCubit)
    const headersState = useCubit<DataTableState>(props.headersCubit)
    const footersState = useCubit<DataTableState>(props.footersCubit)
    const [currentSongIndex, setCurrentSongIndex] = useState<number>(0)

    if (
        memoriesState.state === 'LOADING'
        || musicsState.state === 'LOADING'
        || headersState.state === 'LOADING'
        || footersState.state === 'LOADING'
    ) {
        return <></>
    }

    function handleNext() {
        if (currentSongIndex < (musicsState.data!.length - 1)) {
            setCurrentSongIndex(currentSongIndex + 1);
        } else {
            setCurrentSongIndex(0);
        }
    }
    function handlePrevious() {
        if (currentSongIndex > 0) {
            setCurrentSongIndex(currentSongIndex - 1);
        } else {
            setCurrentSongIndex(musicsState.data!.length - 1);
        }
    }

    return (
        <div
            style={{
                backgroundImage: `url("/background-us.jpg")`,
                backgroundRepeat: "repeat",
                // backgroundSize: "cover",
                width: "calc(100% - 12px)"
            }}
        >
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div
                        className="card"
                        style={{
                            backgroundColor: "rgba(26,26,26,0.9)",
                            marginBottom: 129
                        }}
                    >
                        <Header header={headersState.data![headersState.data!.length - 1]} />
                        <VerticalTimeline animate={false}>
                            {memoriesState.data!.sort((a, b) => {
                                return a.date.seconds - b.date.seconds
                            }).map((v, i) => {
                                return <VerticalTimelineElement
                                    key={`Memory#${v.id}`}
                                    className="vertical-timeline-element--work"
                                    contentStyle={{
                                        background: "#262626",
                                        color: "#fff",
                                        objectFit: "cover",
                                    }}
                                    contentArrowStyle={{
                                        borderRight:
                                            "7px solid  rgb(26, 26, 26)",
                                    }}
                                    date={v.date.toDate().toDateString()}
                                    iconStyle={{
                                        background: "rgb(26, 26, 26)",
                                        color: "#ff1493",
                                    }}
                                    icon={<GiRose />}
                                    style={{
                                        padding: 0,
                                    }}
                                >
                                    <div>
                                        {v.video !== undefined
                                            ? <ReactPlayer controls url={v.video} width={"100%"} />
                                            : <a
                                                href={v.video ?? v.image}
                                                target="_blank"
                                                rel="noreferrer"
                                            ><img
                                                    src={v.image}
                                                    alt={v.title}
                                                    style={{
                                                        width: "100%",
                                                        borderRadius: 10,
                                                    }}
                                                />
                                            </a>
                                        }
                                    </div>
                                    <div
                                        style={{
                                            padding: 5,
                                        }}
                                    >
                                        <h3 className="vertical-timeline-element-title">
                                            {v.title}
                                        </h3>
                                        <h4 className="vertical-timeline-element-subtitle">
                                            {v.date.toDate().toDateString()}
                                        </h4>
                                        <p>{v.description}</p>
                                    </div>
                                </VerticalTimelineElement>
                            }
                            )}
                        </VerticalTimeline>
                        <Footer footer={footersState.data![footersState.data!.length - 1]} />
                        <div className='row justify-content-center'>
                            <AudioPlayer
                                style={{
                                    position: "fixed",
                                    bottom: 0,
                                    width: "100%"
                                }}
                                autoPlay={true}
                                onEnded={handleNext}
                                src={musicsState.data![currentSongIndex].audio}
                                showSkipControls
                                showJumpControls={false}
                                onClickNext={handleNext}
                                onClickPrevious={handlePrevious}
                                autoPlayAfterSrcChange={true}
                                customAdditionalControls={[<div style={{
                                    display: "flex",
                                    flex: "row",
                                }}>
                                    <img
                                        src={musicsState.data![currentSongIndex].cover}
                                        alt={`${musicsState.data![currentSongIndex].title}'s song cover`}
                                        style={{
                                            width: 65,
                                            height: 65,
                                            borderRadius: 45
                                        }}
                                    />
                                    <div style={{
                                        padding: 8
                                    }}>
                                        <h5>Now playing</h5>
                                        <p>▶{musicsState.data![currentSongIndex].title}</p>
                                    </div>

                                </div>]}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Zahra;